import {v4 as uuid} from 'uuid';
import {config} from "../config";

export const formatAMPM = (timestamp: any) => {
    let date = new Date(timestamp * 1000);
    let hours = date.getHours();
    let minutes: string | number = date.getMinutes();
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}

export const splitIntoSentencesWithUID = (text: string) => {
    // Split text into sentences using a simple regex
    const sentences = text.match(/[^\.!\?]+[\.!\?]+/g) || [];

    // Map each sentence to an object with the sentence and its UID
    return sentences.map((sentence, index) => ({
        uid: uuid(),
        sentence: sentence.trim()
    }));
}


export const splitIntoSentencesGroupsWithUID = (text: string) => {
    const sentences = text.match(/[^\.!\?]+[\.!\?]+/g) || [];

    // Create an array to hold the groups of three sentences
    const sentenceGroups = [];

    for (let i = 0; i < sentences.length; i += 3) {
        // Take the next three sentences and join them into one string
        const group = sentences.slice(i, i + 3).map((sentence) => sentence.trim()).join(' ');

        // Assign a UID to the group
        const uid = uuid();

        // Push the group with its UID to the result array
        sentenceGroups.push({
            uid,
            sentence: group
        });
    }

    return sentenceGroups;
}

export const cleanStringForAvatar = (text: string) => {
    return text
        .replace(/[\r\n]+/g, '') // Remove all \r and \n characters
        .replace(/\[.*?\]/g, '') // Remove all [square bracketed] text
        .replace(/\(.*?\)/g, '')
        .replace(/\bCiscape\b/gi, 'Sigh-scape')
        .replace(/\bEdo\b/gi, 'E-dough')
        .replace(/\bGenAI\b/gi, 'Jenn-A-I')
        .replace(/\btech\b/gi, 'Tech')// Remove all (parenthesized) text
        .replace(/https?:\/\/\S+/g, '');
}
export const getEnvironment = () => {
    const currentUrl = (window as any).location.href;
    let environment = 'production';
    if (currentUrl.includes("touchcastmaas.dev")) {
        environment = 'dev';
    } else if (currentUrl.includes("touchcastmaasstage.com")) {
        environment = 'stage';
    }
    return environment;
}

export const getApiUrl = () => {
    let apiUrl = config.apiUrl;
    /*const currentUrl = (window as any).location.href;
    if (currentUrl.includes("ciscape.com") || currentUrl.includes("touchcastmaas.com") || currentUrl.includes("genything.ai")) {
        if (currentUrl.includes("genything.ai")) {
            apiUrl = 'https://genything.ai/';
        } else if (currentUrl.includes("touchcastmaas.com")) {
            apiUrl = 'https://touchcast.touchcastmaas.com/synth/';
        } else {
            apiUrl = 'https://touchcast.ciscape.com/synth/';
        }
    } else if (currentUrl.includes("touchcastmaasstage.com")) {
        apiUrl = 'https://touchcast.touchcastmaasstage.com/synth/';
    }
    return apiUrl;*/
    const currentOrigin = (window as any).location.origin;
    if (!currentOrigin.includes("genything.ai")) {
        apiUrl = currentOrigin + '/synth/'
    } else {
        apiUrl = currentOrigin + '/'
    }
    //apiUrl = 'https://touchcast.touchcastmaas.dev/synth/'
    return apiUrl
}
export const getPdfBackendUrl = () => {
    const currentUrl = (window as any).location.href;
    let pdfApiUrl = config.socketUrl;
    // if (currentUrl.includes("ciscape.com") || currentUrl.includes("touchcastmaas.com") || currentUrl.includes("genything.ai")) {
    //     pdfApiUrl = pdfApiUrl.replace(".dev", ".com");
    // } else if (currentUrl.includes("touchcastmaasstage.com")) {
    //     pdfApiUrl = pdfApiUrl.replace(".dev", "stage.com");
    // }
    if (currentUrl.includes("ciscape.com") || currentUrl.includes("touchcastmaas.com") || currentUrl.includes("touchcastmaasstage.com") || currentUrl.includes("genything.ai")) {
        pdfApiUrl = pdfApiUrl.replace(".dev", ".com");
    }
    return pdfApiUrl;
}

export const isAccentureTwin = (profilePath: string): boolean => {
    if (profilePath === 'danakoch' || profilePath === 'johngoodyer' || profilePath === 'jessmajekodunmi' || profilePath === 'simonholland') {
        return true
    }
    return false
}
